import React, { useState } from "react";
import { LinkButton } from "../../atoms/Buttons";
import { FormBuilder } from "./FormBuilder";
import * as Icon from "react-feather";
import { H4 } from "../../atoms/Texts";

const generateKey = () => Date.now();

const MultiForm = ({ heading, addNewItem }) => {
  const [count, setCount] = useState([]);

  React.useEffect(() => {
    // set the default for email address by index
    setCount([addNewItem(generateKey())]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <H4 className="mb-4 mt-10 capitalize">{heading}</H4>
      <section>
        {count.map(({ id, fields }) => {
          return (
            <div key={id} className="mb-4">
              <div className="flex-grow grid grid-cols-1 md:grid-cols-2 gap-x-5">
                <FormBuilder fields={fields} />
              </div>

              {count.length > 1 && (
                <LinkButton
                  color="#E62250"
                  className="-mt-0 block cursor-pointer"
                  onClick={() =>
                    setCount((count) => {
                      return count.filter((e) => e.id !== id);
                    })
                  }
                >
                  Delete this {heading}
                </LinkButton>
              )}
              {/* <hr className="mt-2 mb-4" /> */}
            </div>
          );
        })}

        <LinkButton
          type="button"
          onClick={() => setCount([...count, addNewItem(generateKey())])}
          className="flex items-center my-4"
          style={{
            width: "fit-content",
          }}
          noOutline
        >
          Add another {heading}
          <Icon.Plus color="#442ECF" size={12} className="ml-2" />
        </LinkButton>
      </section>
    </>
  );
};

export default MultiForm;
